import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Button, Paper } from '@material-ui/core';
import { buttonStyle, EditWithToolbarStyle } from '../../style';
import PDFPreview from './PDFPreview';

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    width: '75%',
    maxWidth: '90%',
    height: '90%',
    minWidth: '70%',
    minHeight: '60%',
    //backgroundColor: 'white',
    boxShadow: theme.shadows[5],
    padding: 0,
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.shape.borderRadius,
    overflow: 'auto',
    resize: 'both',
  },
  pdfContainer: {
    flexGrow: 1,
    overflow: 'auto',
    width: '100%',
    height: 'calc(100% - 48px)',
    display: 'flex',
    justifyContent: 'center',
    //backgroundColor: 'white',
    position: 'relative',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    '& > *': {
      marginLeft: '0',
    },
  }
}));

const PDFPreviewModal = ({ open, onClose, pdfUrl, onSend, isLoading = false }) => {
  const classes = useStyles();
  const buttonClasses = buttonStyle();
  const editClasses = EditWithToolbarStyle();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modalContainer}
      aria-labelledby="pdf-preview-modal"
      aria-describedby="traffic-instructions-preview"
    >
      <Paper className={classes.modalContent}>
        <div className={classes.pdfContainer}>
          <PDFPreview pdfUrl={pdfUrl} downloadLink={pdfUrl}/>
        </div>
        <div className={classes.buttonContainer}>
          <Button
            className={buttonClasses.button}
            onClick={onSend}
            disabled={isLoading}
            style={{ marginRight: '16px' }}
          >
            {isLoading ? 'Sending...' : 'Send'}
          </Button>
          <Button
            onClick={onClose}
            disabled={isLoading}
            className={editClasses.cancelButton}
            style={{ textTransform: 'none' }}
          >
            Cancel
          </Button>
        </div>
      </Paper>
    </Modal>
  );
};

export default PDFPreviewModal;
